module.exports = __webpack_public_path__ + "img/copy.23bbf57f.svg";